import type { ReactNode } from 'react';

import useStyles from './SelectableCard.styles';

interface SelectableCardProps {
  isSelected: boolean;
  isOnDark?: boolean;
  children: ReactNode;
  name: string;
  value: string;
  disabled?: boolean;
  onSelect: () => void;
  increasePadding?: boolean;
  ariaLabel?: string;
}

const SelectableCard = ({
  isSelected,
  isOnDark = false,
  children,
  increasePadding = false,
  name,
  value,
  disabled,
  onSelect,
  ariaLabel,
}: SelectableCardProps) => {
  const { classes, cx } = useStyles({ increasePadding, isOnDark });

  const handleChange = () => {
    if (!disabled) {
      onSelect();
    }
  };

  return (
    <label
      className={cx(
        classes.selectableCard,
        isSelected && classes.selected,
        disabled && classes.disabled
      )}
    >
      <input
        type='radio'
        name={name}
        value={value}
        checked={isSelected}
        onChange={handleChange}
        className={classes.srOnly}
        aria-label={ariaLabel}
      />
      {children}
    </label>
  );
};

export default SelectableCard;
